import React from "react";

const Bookmark = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="10.889" height="14" viewBox="0 0 10.889 14">
			<path
				id="icon-bookmark"
				d="M14.333,3a1.556,1.556,0,0,1,1.556,1.556V17l-5.444-2.333L5,17V4.556A1.555,1.555,0,0,1,6.556,3h7.778M9.667,6.111V7.667H8.111V9.222H9.667v1.556h1.556V9.222h1.556V7.667H11.222V6.111Z"
				transform="translate(-5 -3)"
				fill="#fff"
				opacity="0.5"
			/>
		</svg>
	);
};

export default Bookmark;
